import { createRouter, createWebHistory  } from 'vue-router'
// import store from '@/store';

// Import the view components
import SolicitudDeMensajeria from '../views/SolicitudDeMensajeria.vue';
import SolicitudCentroCosto from '../views/SolicitudCentroCosto.vue';
import PaginaNoEncontrada from '../views/PaginaNoEncontrada.vue';

const routes = [
    {
      path: '/solicitud-mensajeria',
      name: 'SolicitudDeMensajeria',
      component: SolicitudDeMensajeria,
    },
    {
      path: '/',
      name: 'SolicitudCentroCosto',
      component: SolicitudCentroCosto,
    },
    {
      path: '/:pathMatch(.*)*', //------------------------------------- Vista default, en caso de que no sea ninguna de las rutas anteriores
      name: 'NotFound',
      component: PaginaNoEncontrada,
    },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router